import { render, staticRenderFns } from "./WheatMall.vue?vue&type=template&id=6f209b0d&scoped=true"
import script from "./WheatMall.vue?vue&type=script&lang=js"
export * from "./WheatMall.vue?vue&type=script&lang=js"
import style0 from "./WheatMall.vue?vue&type=style&index=0&id=6f209b0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f209b0d",
  null
  
)

export default component.exports